// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__fEE74","box":"WorkspacesBox_box__3ctGt","node":"WorkspacesBox_node__3sV9X"};